/* eslint-disable react-hooks/exhaustive-deps */
import React, { useEffect, useState } from 'react';
import { recruits } from '../../apis/admin/recruit';
import useForm from '../../hooks/useForm';
import { getParams } from '../../utils/params';
import Filters from '../Filters';
import { ControlTable } from '../Table';
import Recruit from './Recruit';

const Recruits = () => {
  const [fields] = useState([
    { title: "지원공고", key: "recruitTitle" },
    { title: "지원자", key: "name" },
    { title: "이메일", key: "email" },
    { title: "연락처", key: "mobile" },
    { title: "지원일", key: "createdTime", type: 'datetime' },
    {
      type: "button",
      size: "x-sm",
      color: "gray-line",
      label: "상세",
      onClick: ({ data }) => {
        setDetailOpen(true);
        setSelectedItem(data);
      },
    },
  ]);
  const [filters] = useState([{
    title: "공고명",
    key: "search.recruitTitle"
  }, {
    title: "지원자",
    key: "search.name",
  }]);

  const [detailOpen, setDetailOpen] = useState(false);
  const [selectedItem, setSelectedItem] = useState(null);

  const {
    form,
    setSubmit,
    handleOnChange,
    // handleSubmit,
    // LIST 용
    filterSubmit,
    list, setList,
    selectedList, setSelectedList,
    isLoading, setIsLoading,
    total, setTotal,
    page, setPage,
    limit, setLimit,
  } = useForm({
    order: [
      {
        idx: "desc"
      },
    ],
    page: 0,
    limit: 10
  },);

  const submit = (param) => {
    recruits(getParams(param))
      .then(res => {
        const { rows, count } = res;
        setTotal(count);
        setList(rows);
      })
      .finally(() => setIsLoading(false));
  };

  useEffect(() => {
    submit(form);
    setSubmit(submit);
  }, []);


  return (
    <>
      <Filters
        isLoading={isLoading}
        filters={filters}
        submit={filterSubmit}
        form={form}
        onChange={handleOnChange}
      />

      <ControlTable
        fields={fields}
        list={list}
        isLoading={isLoading}
        selectedList={selectedList}
        setSelected={setSelectedList}
        total={total}
        page={page}
        setPage={setPage}
        limit={limit}
        setLimit={setLimit}
        isControl={true}
      />

      <Recruit
        open={detailOpen}
        setOpen={setDetailOpen}
        submit={filterSubmit}
        selectedItem={selectedItem}
        setSelectedItem={setSelectedItem}
      />
    </>
  );
};

export default Recruits;